<template>
  <div>
    <notifications
      :duration="10000"
      position="bottom right"
      width="50%"
    />
    <div
      v-if="showWaitSpinner"
      class="divWaitSpinner"
    >
      <div class="spinnerBackground">
        <spinner
          class="spinner"
          message="Loading..." />
      </div>
    </div>
    <PageHeader v-if="!printerFriendly && !redirectToWCMS" />
    <div
      id="content-main"
      tabindex="-1"
      role="main"
      class="container bg-white">
      <router-view />
    </div>
    <PageFooter v-if="!printerFriendly && !redirectToWCMS" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Spinner from 'vue-simple-spinner';
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
// import { mapGetters } from 'vuex';

export default {
  components: {
    Spinner,
    PageHeader,
    PageFooter,
  },
  computed: {
    ...mapState({
      apiErrors: state => state.apiErrors,
      dataErrors: state => state.dataErrors,
    }),
    ...mapGetters([
      'printerFriendly',
      'showWaitSpinner',
    ]),
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    // when true, supress the header/footer and initial api calls
    // to minimize visual disturbance before the redirect
    redirectToWCMS() {
      // the beforeEnter method on the wcms route causes the route name to be null
      return this.$route.name === 'wcms' || this.$route.name === null;
    },
  },
  watch: {
    apiErrors() {
      if (this.apiErrors.length > 0) {
        const err = this.apiErrors[this.apiErrors.length - 1];
        this.$notify({
          type: 'error',
          title: 'API error',
          text: `${err.request.responseURL} ${err.message}`,
        });
      }
    },
    dataErrors() {
      if (this.dataErrors.length > 0) {
        this.dataErrors.forEach((error) => {
          this.$notify({
            type: 'error',
            title: 'Data error',
            text: error,
          });
        });
      }
    },
  },
  created() {
    this.setStateFromQueryStringParms();
    if (!this.redirectToWCMS) {
      this.$store.dispatch('getInitialApiData');
    }
  },
  methods: {
    getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey) {
      return this.$store.getters
        .getDefaultFromQueryStringParmIfInitialPageLoad(defaultValue, queryStringKey);
    },
    setStateFromQueryStringParms() {
      this.$store.commit('setShowDebugIds', this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'showDebugIds'));
      this.$store.commit('setShowMode', this.getDefaultFromQueryStringParmIfInitialPageLoad('', 'showMode'));
    },
  },
};
</script>

<style scoped>
  .divWaitSpinner {
    z-index: 9999;
    position: fixed;
  }

  .spinnerBackground {
    width: 200px;
    height: 200px;
    background-color: #CFCFCF;
    position: fixed;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  .spinner {
    margin-top: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue